export class UserProfileViewModel {
  id: string = '';
  name: string = '';
  email: string = '';
  connection: string = '';
  picture: string = '';
  hasLoggedIn: boolean = false;
}
